module.exports = __webpack_public_path__ + "img/working-man.7382aa8e.png";